/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StripeAccountsOnboardingResponse
 */
export interface StripeAccountsOnboardingResponse {
    /**
     * 
     * @type {string}
     * @memberof StripeAccountsOnboardingResponse
     */
    accountUrl: string;
}

/**
 * Check if a given object implements the StripeAccountsOnboardingResponse interface.
 */
export function instanceOfStripeAccountsOnboardingResponse(value: object): value is StripeAccountsOnboardingResponse {
    if (!('accountUrl' in value) || value['accountUrl'] === undefined) return false;
    return true;
}

export function StripeAccountsOnboardingResponseFromJSON(json: any): StripeAccountsOnboardingResponse {
    return StripeAccountsOnboardingResponseFromJSONTyped(json, false);
}

export function StripeAccountsOnboardingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StripeAccountsOnboardingResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'accountUrl': json['accountUrl'],
    };
}

export function StripeAccountsOnboardingResponseToJSON(json: any): StripeAccountsOnboardingResponse {
    return StripeAccountsOnboardingResponseToJSONTyped(json, false);
}

export function StripeAccountsOnboardingResponseToJSONTyped(value?: StripeAccountsOnboardingResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accountUrl': value['accountUrl'],
    };
}

